import { render } from "./SyncModal.vue?vue&type=template&id=89e20226"
import script from "./SyncModal.vue?vue&type=script&lang=js"
export * from "./SyncModal.vue?vue&type=script&lang=js"
script.render = render

export default script